/**
 * Formats a date string to a relative format (e.g., "2 days ago")
 * with the absolute date available on hover/tooltip
 */
export const formatRelativeDate = (
  dateString: string
): {
  relative: string;
  absolute: string;
} => {
  const date = new Date(dateString);
  const now = new Date();
  const diffInMs = now.getTime() - date.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  // Format absolute date for tooltip
  const absolute = date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  if (diffInDays === 0) {
    return { relative: "Today", absolute };
  } else if (diffInDays === 1) {
    return { relative: "Yesterday", absolute };
  } else if (diffInDays < 7) {
    return { relative: `${diffInDays} days ago`, absolute };
  } else if (diffInDays < 30) {
    const weeks = Math.floor(diffInDays / 7);
    return {
      relative: `${weeks} ${weeks === 1 ? "week" : "weeks"} ago`,
      absolute,
    };
  } else if (diffInDays < 365) {
    const months = Math.floor(diffInDays / 30);
    return {
      relative: `${months} ${months === 1 ? "month" : "months"} ago`,
      absolute,
    };
  } else {
    const years = Math.floor(diffInDays / 365);
    return {
      relative: `${years} ${years === 1 ? "year" : "years"} ago`,
      absolute,
    };
  }
};
